import { useEffect, useState } from "react";
import { AppConstant } from "constants/AppConstant";
import { IdamUser } from "../types";
import { AuthenticationProviders } from "constants/AuthenticationProviders";

export const useAuthUser = () => {
  const [userInfo, setUserInfo] = useState<IdamUser>();

  useEffect(() => {
    const userDataFromSessionStorage: any =
      sessionStorage.getItem("userInfo") || "";
    const appAuthProvider: any = AppConstant.authentication;

    switch (appAuthProvider?.provider) {
      case AuthenticationProviders.IDAM:
        return setUserInfo(JSON.parse(userDataFromSessionStorage || null));

      // NB: not currently possible to go down the default case
      default:
        return setUserInfo(undefined);
    }
  }, []);

  return userInfo;
};
